import { IRequest } from '@r1-frontend/shared/types/IRequest';

export interface IActivateWatchEverywhereResponseDto {
    tvSlotsCount: number,
}

/**
 * Подключение услуги "Смотри везде"
 * @link https://master.api-profile.sandbox.d2c.r-one.io/docs/v1#/DomruTv/2bb06d87a5b5ad175d3fb51acbaf42e5
 */
export const activateWatchEverywhere = (body: { serviceId: number }): IRequest => ({
    uri: '/v1/domru-tv/everywhere-watch-on',
    method: 'POST',
    withAuth: true,
    withProvider: true,
    body: JSON.stringify(body),
});
